import React from "react";
import './ExternalLink.scss'

export default ({href, className = '', children}) => {
    return (
        <a className={`external-link ${className}`} href={href} target={'_blank'} rel="noopener noreferrer">
            {children}
        </a>
    )
}